import { Moment } from 'moment';
export class InversionistaDetalle {
  checked:any;
  idComprobante: number=0;
  Tipo_Comprobante:string;
  Serie:any;
  Numero:any;
  Tipo:any;
  Fecha_de_Pago: Moment;
  Plazo =  0;
  VNPP  = '0.00';
  Valor_Venta = '0.00';
  IGV_Factura_Porcentaje = '0.18';
  IGV_Factura_Importe ='0.00';
  Precio_Venta = '0.00';
  Total_Honorario = '0.00';
  Retencion_RH_Porcentaje = 0;
  Retencion_RH_Importe = '0.00';
  Total_Recibido = '0.00';
  Detraccion_Porcentaje = 0;
  Detraccion_Importe = 0;
  Retencion_Porcentaje = 0;
  Retencion_Base: number = 72;
  Retencion_Importe = 0;
  Fondo_Garantia_Porcentaje = 0;
  Fondo_Garantia_Base:number = 72 ;
  Fondo_Garantia_Importe = 0;
  Otros_Descuentos = 0;
  Adelanto = 0;
  Interes = 0;
  Comision = 0;
  Desembolso = 0;
  Remanente = 0;
  TEM = 0;
  pPAdelanto = 0;
  Moneda: number = 2;
  IGV = 0;
  Porcentaje_Interes_Adquirente: number;
  InteresAdq = 0;
  InteresProv = 0;
  IGVProv = 0;
  DesembolsoProvConfirming= 0;
  ComisionTotal = 0;
  Saldo_Actual = '0.00';
  Monto_Disponible = '0.00';
  Tipo_Servicio = 132;
  Valor_Inversion = 0;
  porcentaje_retroventa: number= 0;
  Proporcion_Retroventa= 0;
  porcentaje_rendimiento= 0;
  porcentaje_rendimiento_show= 0;
  rendimiento= 0;
  valor_vencimiento= 0;
  costo_asesoria= 0;
  iva_asesoria= 0;
  rendimiento_neto= 0;
  valor_recibir= 0;
  porcentaje_rendimiento_neto= 0;
  Inversionista = '';
  InversionistaFondo = '';
  idFondo = '';
  fecha_inversion = '';
  retencion_fuente = 0;
  retencion_iva = 0;
  valor_neto = 0;
  retencionFuentePorcentaje = 0.3;
  retencionIVAPorcentaje = 0.7;
  
}
